import { Badge } from '@/components/ui/badge';
import type { FC } from 'react';

export const SubscriptionStatusBadge: FC<{
    isSubscribed: boolean;
    variant?: 'text' | 'badge';
    size?: 'default' | 'sm' | 'xs';
}> = ({ isSubscribed, variant = 'badge', size = 'default' }) => {
    const sizeClass = size === 'xs' ? 'text-xs' : '';

    if (variant === 'text') {
        return isSubscribed ? (
            <span className="text-green-600 font-medium">Yes</span>
        ) : (
            <span className="text-red-600 font-medium">No</span>
        );
    }

    return isSubscribed ? (
        <Badge variant="default" className={`bg-green-600 ${sizeClass}`}>
            Subscribed
        </Badge>
    ) : (
        <Badge variant="outline" className={sizeClass}>
            Not Subscribed
        </Badge>
    );
};
